import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { DerogationComponent } from './derogation.component';
import { EditFormComponent } from './edit-form/edit-form.component';
import { SharedModule } from 'app/shared/shared.module';

@NgModule({
    declarations: [
        DerogationComponent,
        EditFormComponent
    ],
    imports: [
        CommonModule,
        SharedModule,
        FormsModule
    ]
})
export class DerogationModule { }
